import {Component} from '@angular/core';
import {RequisitesType} from '../../base/requisites/requisites.component';

@Component({
  selector: 'app-requisites-ru',
  templateUrl: './requisites-ru.component.html',
})
export class RequisitesRuComponent {
  requisites: Array<RequisitesType> = [
    {
      name: 'ИП Мизгирева Анастасия Витальевна',
      inn: '246114318367',
      city: 'г. Абакан',
      legalAddress: 'г. Красноярск, ул. Алеши Тимошенкова д 175, кв 4',
      tel: '+79235852945',
      whatsApp: '+79235852945',
      whatsAppLink: 'https://wa.me/79235852945',
      email: 'rentps@ya.ru',
    },
    {
      name: 'ИП Хасаншин Артур Рустамович',
      inn: '164410768820',
      city: 'г. Альметьевск',
      legalAddress: '423455, Республика Татарстан, город Альметьевск, ул. Шевченко, дом 70, кв. 24',
      tel: '+79534980728',
      whatsApp: '+79534980728',
      whatsAppLink: 'https://wa.me/79534980728',
      email: 'war10ck@mail.ru',
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Анапа',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      name: 'ИП Мотякин Руслан Вячеславович',
      inn: '250108169465',
      city: 'г. Арсеньев',
      legalAddress: 'Россия, Приморский край г.Арсеньев ул. Садовая 14 кв.58',
      tel: '+79996165251',
      email: 'vika.khalimanchuk.91@bk.ru',
    },
    {
      name: 'ИП Переломов Алексей Викторович',
      inn: '290108150406',
      city: 'г. Архангельск',
      legalAddress: '163045 г. Архангельск ул. Розинга д. 6 кв. 74',
      tel: '+79115980177',
      telegram: 'busyfly_29',
      telegramLink: 'https://t.me/busyfly_29',
      email: 'p-tehno@yandex.ru',
    },
    {
      name: 'ИП Киселева Татьяна Владимировна',
      inn: '244311798743',
      city: 'г. Ачинск',
      legalAddress: 'Красноярский край, г. Ачинск, микрорайон 5 дом 40 кв 46',
      tel: '+79233088008',
      whatsApp: '+79233088008',
      whatsAppLink: 'https://wa.me/79233088008',
      viber: '+79233088008',
      email: 'kiceleva8@gmail.com',
    },
    {
      name: 'ИП Киселев Максим Олегович',
      inn: '244314979191',
      city: 'г. Ачинск',
      legalAddress: '662150, Россия, Красноярский край г. Ачинск микрорайон Авиатор д.26 кв.65',
      tel: '89233070770',
    },
    {
      name: 'ИП Куликов Дмитрий Алексеевич',
      inn: '301905026541',
      city: 'г. Астрахань',
      legalAddress: '414011, Россия, г. Астрахань, ул. Космическая дом 6 офис 9',
      tel: '+79881720444',
      whatsApp: '+79881720444',
      whatsAppLink: 'https://wa.me/79881720444',
      email: 'tango-astr@yandex.ru',
    },
    {
      name: 'ИП Кузнецов Игорь Евгеньевич',
      inn: '631930113386',
      city: 'г. Балаково',
      legalAddress: '443028, Россия, г. Самара, п. Мехзавод, ул. 1й квартал, дом 38, кв. 228',
      whatsApp: '+79270274232',
      whatsAppLink: 'https://wa.me/79270274232',
      telegram: 'BusyFly_Samara_Support',
      telegramLink: 'https://t.me/BusyFly_Samara_Support',
      email: 'busyflypartners@mail.ru',
    },
    {
      name: 'ИП Афанасьева Вероника Олеговна',
      inn: '390508305174',
      city: 'г. Балтийск',
      legalAddress: 'Россия, 236019, Калининградская область, город Калининград,  улица Беланова, дом 27, квартира 57',
      viber: '+79097894545 (Работает только в режиме чата)',
      telegram: 'BusyFly_Kgd39',
      telegramLink: 'https://t.me/BusyFly_Kgd39',
      email: 'busy.fly@mail.ru'
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Белореченск',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      name: 'ИП Сутягина Валентина Викторовна',
      inn: '880100127557',
      city: 'г. Бердянск',
      legalAddress: '',
    },
    {
      name: 'ООО АХАХА',
      inn: '6678113130',
      city: 'г. Березовский',
      legalAddress: 'Свердловская обл., г. Березовский, ул. Энергостроителей, д. 6, кв. 46',
      tel: '+79827571522',
      whatsApp: '+79827571522',
      whatsAppLink: 'https://wa.me/79827571522',
      telegram: 'samokatekat',
      telegramLink: 'https://t.me/samokatekat',
      viber: '+79827571522',
      email: 'samokat.ekat@mail.ru',
    },
    {
      name: 'ИП Мизгирева Анастасия Витальевна',
      inn: '246114318367',
      city: 'г. Бийск',
      legalAddress: 'г. Красноярск, ул. Алеши Тимошенкова д 175, кв 4',
      tel: '+79235852945',
      whatsApp: '+79235852945',
      whatsAppLink: 'https://wa.me/79235852945',
      email: 'rentps@ya.ru',
    },
    {
      name: 'ИП Чижевская Анастасия Ивановна',
      inn: '246112003883',
      city: 'г. Бийск',
      legalAddress: 'Красноярский край, г.Красноярск, ул.Апрельская д.4 кв.517',
      tel: '+7 905 997 9275',
      email: 'ochuev2021@yandex.ru',
    },
    {
      name: 'ИП Баскоев Сергей Сергеевич',
      inn: '25701729114',
      city: 'г. Бирск',
      legalAddress: 'Республика Башкортостан г. Бирск, ул.Ленина 23а, кв 1',
      tel: '+79684711818',
      email: 'dop@baskoev.ru',
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Благовещенская',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      name: 'ИП Морозова Елена Сергеевна',
      inn: '773272780973',
      city: 'г. Бугульма',
      legalAddress: '119620, Россия, г. Москва, Солнцевский пр-кт д.15, кв.21',
      tel: '89035630806',
      email: 'Alexandr19862017@mail.ru'
    },
    {
      name: 'ООО Шале Лайф',
      inn: '3257009699',
      city: 'г. Брянск',
      legalAddress: '241043, Россия, Брянская обл., Брянский район, п. Бело-Бережский санаторий Турбаза, ул. Санаторная, дом 8, офис 1',
      tel: '+74832320320',
      email: 'info@millwood.club',
    },
    {
      name: 'ООО АХАХА',
      inn: '6678113130',
      city: 'г. Верхняя Пышма',
      legalAddress: 'Свердловская обл., г. Березовский, ул. Энергостроителей, д. 6, кв. 46',
      tel: '+79827571522',
      whatsApp: '+79827571522',
      whatsAppLink: 'https://wa.me/79827571522',
      telegram: 'samokatekat',
      telegramLink: 'https://t.me/samokatekat',
      viber: '+79827571522',
      email: 'samokat.ekat@mail.ru',
    },
    {
      name: 'ИП Черников Александр Владимирович',
      inn: '773208667988',
      city: 'г. Владимир',
      legalAddress: '119313, г. Москва, Ленинский проспект 88к3, кв 101',
      whatsApp: '+79042605656',
      whatsAppLink: 'https://wa.me/79042605656',
      telegram: 'BusyFly33',
      telegramLink: 'https://t.me/BusyFly33',
      email: 'pro1702@gmail.com',
    },
    {
      name: 'ИП Вайсман Дмитрий Олегович',
      inn: '110306792433',
      city: 'г. Воркута',
      legalAddress: 'Россия, г. Воркута Б-Шерстнева 2-186',
      tel: '+79222759078',
      whatsApp: '+79222759078',
      whatsAppLink: 'https://wa.me/79222759078',
      telegram: 'Dmitry_Vaysman',
      telegramLink: 'https://t.me/Dmitry_Vaysman',
      email: 'komrad.vaysman2016@yandex.ru',
    },
    {
      name: 'ИП Рамазанов Султанбек Амиргамзаевич',
      inn: '054805043408',
      city: 'г. Воронеж',
      legalAddress: 'Россия, г. Избербаш. ул. Ритм 445',
      tel: '+79038517294',
      telegram: 'ramazanovsss',
      telegramLink: 'https://t.me/ramazanovsss',
      email: 'ramazanovrrrsss@mail.ru',
    },
    {
      name: 'ИП Баранов Андрей Анатольевич',
      inn: '524706783364',
      city: 'г. Выкса',
      legalAddress: '607060, г. Выкса, Нижегородская обл., 30 лет Комсомола 8',
      tel: '+79103855320',
      viber: '+79103855320',
      whatsApp: '+79103855320',
      whatsAppLink: 'https://wa.me/79103855320',
      telegram: 'samokatvyksa',
      telegramLink: 'http://t.me/samokatvyksa',
      email: 'Postersss2@yandex.ru'
    },
    {
      name: 'ИП Муратов Григорий Анатольевич',
      inn: '164491602933',
      city: 'г. Геленджик',
      legalAddress: '42308, Республика Татарстан, г. Альметьевск,  мкр. Урсала, ул. Рыжикова, д. 19А',
      tel: '+7(917)9211662',
      email: 'ursala@yandex.ru',
    },
    {
      name: 'ИП Мизгирева Анастасия Витальевна',
      inn: '246114318367',
      city: 'г. Горно-Алтайск',
      legalAddress: 'г. Красноярск, ул. Алеши Тимошенкова д 175, кв 4',
      tel: '+79235852945',
      whatsApp: '+79235852945',
      whatsAppLink: 'https://wa.me/79235852945',
      email: 'rentps@ya.ru',
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Горячий Ключ',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      city: 'г. Грозный',
      name: 'ИП Ерохина Кристина Олеговна',
      inn: '541003491220',
      legalAddress: 'Россия, Чеченская республика, г.Грозный, р-н Шейх-Мансуровский, ул. им Ю.П. Погуляева, д. 25',
      telNoteAlarm: 'Нет технической поддержки',
      tel: '+7 (928) 476-11-88',
      email: 'kris@arusnavi.ru'
    },
    {
      city: 'г. Грозный',
      name: 'ООО «СМАРТ ТРАНС»',
      inn: '2013011677',
      legalAddress: '364022, Россия, Чеченская Республика, г. Грозный, р-н Шейх-Мансуровский, ул. им. Батаева, двлд. 102',
      tel: '8 938 140 55 55',
      email: 'irsgroup_work@mail.ru'
    },
    {
      name: 'ИП Киселева Валерия Александровна',
      inn: '290128159608',
      city: 'г. Дербент',
      legalAddress: 'г. Дербент, ул. З.Космодемьянской д 3',
      whatsApp: '+79115879077',
      whatsAppLink: 'https://wa.me/79115879077',
      tel: '+79115879077',
      telegram: 'BusyFly_Derbent',
      telegramLink: 'https://t.me/BusyFly_Derbent',
      viber: 'BusyFlyDerbent',
      viberLink: 'https://invite.viber.com/?g=2DQxmg7kbE8FNTlQXjkI0Oaui5Tq_vP1',
      email: 'artemkise@yandex.ru',
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Ейск',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      name: 'ООО АХАХА',
      inn: '6678113130',
      city: 'г. Екатеринбург',
      legalAddress: 'Свердловская обл., г. Березовский, ул. Энергостроителей, д. 6, кв. 46',
      tel: '+79827571522',
      whatsApp: '+79827571522',
      whatsAppLink: 'https://wa.me/79827571522',
      telegram: 'samokatekat',
      telegramLink: 'https://t.me/samokatekat',
      viber: '+79827571522',
      email: 'samokat.ekat@mail.ru',
    },
    {
      name: 'ИП Мокриенко Максим Станиславович',
      inn: '410551730956',
      city: 'г. Елизово',
      legalAddress: '3684017, Россия, Камчатский край, Елизовский р-н, посёлок Светлый, ул. Кооперативная, д. 11',
      tel: '+79024620906',
      whatsApp: '+79024620906',
      whatsAppLink: 'https://wa.me/79024620906',
      telegram: 'elizovo_busyfly',
      telegramLink: 'https://t.me/elizovo_busyfly',
      email: 'mpowerless@gmail.com',
    },
    {
      name: 'ИП Филиппов Андрей Вячеславович',
      inn: '245015040550',
      city: 'г. Енисейск',
      legalAddress: 'г. Канск, ул. Революции д.4, кв.21',
      tel: '+79095230772',
      email: 'andreiiifil@mail.ru',
    },
    {
      name: 'ИП Рябушкин Владислав Витальевич',
      inn: '641300661358',
      city: 'г. Ершов',
      legalAddress: 'Россия, Саратовская область, г. Ершов, ул. 50 лет Октября д. 1, кв. 2',
      tel: '+79873616406',
      whatsApp: '+79873616406',
      whatsAppLink: 'https://wa.me/79873616406',
      telegram: 'Saratov_region_BusyFly',
      telegramLink: 'https://t.me/Saratov_region_BusyFly',
      email: 'Vlad15792@yandex.ru',
    },
    {
      name: 'ИП Маричева Татьяна Валентиновна',
      inn: '463302744931',
      city: 'г. Железногорск',
      legalAddress: 'Россия, 307176, Курская обл., г. Железногорск, ул. Ленина 58к3',
      tel: '+79692030424',
      email: 'maricheff.artem@yandex.ru',
    },
    {
      name: 'ИП Яковлев Николай Сергеевич',
      inn: '245305571714',
      city: 'г. Зеленогорск',
      legalAddress: '660012 г.Красноярск ул.Судостроительная д.101 кв 33',
      tel: '+79831621051',
      whatsApp: '+79994406780',
      whatsAppLink: 'https://wa.me/79994406780',
      email: 'nikolaj-yakovlev-93@mail.ru',
    },
    {
      name: 'ИП Афанасьева Вероника Олеговна',
      inn: '390508305174',
      city: 'г. Зеленоградск',
      legalAddress: 'Россия, 236019, Калининградская область, город Калининград,  улица Беланова, дом 27, квартира 57',
      viber: '+79097894545 (Работает только в режиме чата)',
      telegram: 'BusyFly_Kgd39',
      telegramLink: 'https://t.me/BusyFly_Kgd39',
      email: 'busy.fly@mail.ru'
    },
    {
      name: 'ИП Войнова Елена Николаевна',
      inn: '720207067701',
      city: 'г. Зеленогорск',
      legalAddress: 'Россия, Тюменская область, г. Тюмень, ул. Елизарова, д. 6, кв. 99',
      tel: '88005502187',
      email: 'toplivot@inbox.ru',
    },
    {
      name: 'ИП Курманалиев Валихан Ахметович',
      inn: '081301644918',
      city: 'г. Знаменск',
      legalAddress: 'Россия, Астраханская область, г.Знаменск, ул.Астраханская, д.7А, кв.54',
      tel: '+79678232353',
      email: 'kurmanalieva1991@bk.ru',
    },
    {
      name: 'ИП Рамазанов Султанбек Амиргамзаевич',
      inn: '054805043408',
      city: 'г. Избербаш',
      legalAddress: 'Россия, г. Избербаш. ул. Ритм 445',
      tel: '+79038517294',
      telegram: 'ramazanovsss',
      telegramLink: 'https://t.me/ramazanovsss',
      email: 'ramazanovrrrsss@mail.ru',
    },
    {
      name: 'ИП Шалыгин Роман Дмитриевич',
      inn: '720506854070',
      city: 'г. Ишим',
      legalAddress: 'Россия, Тюменская обл, г. Ишим, Щорса д.8',
      tel: '+79199291335',
      email: 'SAMOKAT72RUS@MAIL.RU',
    },
    {
      name: 'ООО Ферст Групп',
      inn: '7707674286',
      city: 'г. Калининград',
      legalAddress: '236022,Россия, г. Калининград, ул Кирова, д.7, помещение 6',
      tel: '+79269960066',
      whatsApp: '+79269960066',
      whatsAppLink: 'https://wa.me/79269960066',
      email: '9960066@gmail.com',
    },
    {
      name: 'ИП Афанасьева Вероника Олеговна',
      inn: '390508305174',
      city: 'г. Калининград',
      legalAddress: 'Россия, 236019, Калининградская область, город Калининград,  улица Беланова, дом 27, квартира 57',
      viber: '+79097894545 (Работает только в режиме чата)',
      telegram: 'BusyFly_Kgd39',
      telegramLink: 'https://t.me/BusyFly_Kgd39',
      email: 'busy.fly@mail.ru'
    },
    {
      name: 'ИП Хохлов Илья Адреевич',
      inn: '246315623547',
      city: 'г. Каменск-Уральский',
      legalAddress: 'г. Красноярск, ул. Лесопарковая, д.9, кв.223',
      tel: '+79193195511',
      whatsApp: '+79193195511',
      whatsAppLink: 'https://wa.me/79193195511',
      email: 'ipkhohohlov@yandex.ru',
    },
    {
      name: 'ИП Филиппов Андрей Вячеславович',
      inn: '245015040550',
      city: 'г. Канск',
      legalAddress: 'г. Канск, ул. Революции д.4, кв.21',
      tel: '+79095230772',
      email: 'andreiiifil@mail.ru',
    },
    {
      name: 'ИП Рамазанов Султанбек Амиргамзаевич',
      inn: '054805043408',
      city: 'г. Каспийск',
      legalAddress: 'Россия, г. Избербаш. ул. Ритм 445',
      tel: '+79038517294',
      telegram: 'ramazanovsss',
      telegramLink: 'https://t.me/ramazanovsss',
      email: 'ramazanovrrrsss@mail.ru',
    },
    {
      name: 'ИП Фадеев Андрей Михайлович',
      inn: '231151078703',
      city: 'г. Кемерово',
      legalAddress: 'г. Краснодар, ул. Темрюкская д. 28',
      tel: '+79615265818',
      email: 'gt.20000@ya.ru',
    },
    {
      name: 'ИП Войнова Елена Николаевна',
      inn: '720207067701',
      city: 'г. Кингисепп',
      legalAddress: 'Россия, Тюменская область, г. Тюмень, ул. Елизарова, д. 6, кв. 99',
      tel: '88005502187',
      email: 'toplivot@inbox.ru',
    },
    {
      name: 'ИП Голубев Михаил Игоревич',
      inn: '440118980752',
      city: 'г. Кострома',
      legalAddress: 'г. Косторома, ул. Голубкова, д. 17а',
      telegram: 'samokat_kostroma',
      telegramLink: 'https://t.me/samokat_kostroma',
      tel: '+89670573525',
      email: 'mg.mos@mail.ru',
    },
    {
      name: 'ИП Войнова Елена Николаевна',
      inn: '720207067701',
      city: 'г. Колпино',
      legalAddress: 'Россия, Тюменская область, г. Тюмень, ул. Елизарова, д. 6, кв. 99',
      tel: '88005502187',
      email: 'toplivot@inbox.ru',
    },
    {
      name: 'ИП Кузнецов Игорь Евгеньевич',
      inn: '631930113386',
      city: 'г. Коломна',
      legalAddress: '443028, Россия, г. Самара, п. Мехзавод, ул. 1й квартал, дом 38, кв. 228',
      whatsApp: '+79270274232',
      whatsAppLink: 'https://wa.me/79270274232',
      telegram: 'BusyFly_Samara_Support',
      telegramLink: 'https://t.me/BusyFly_Samara_Support',
      email: 'busyflypartners@mail.ru',
    },
    {
      name: 'ИП Кузнецов Игорь Евгеньевич',
      inn: '631930113386',
      city: 'г. Кошелев',
      legalAddress: '443028, Россия, г. Самара, п. Мехзавод, ул. 1й квартал, дом 38, кв. 228',
      whatsApp: '+79270274232',
      whatsAppLink: 'https://wa.me/79270274232',
      telegram: 'BusyFly_Samara_Support',
      telegramLink: 'https://t.me/BusyFly_Samara_Support',
      email: 'busyflypartners@mail.ru',
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Кореновск',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      name: 'ИП Токмашева Юлия Сергеевна',
      inn: '190117333876',
      city: 'г. Красноярск',
      legalAddress: 'Россия, Красноярский край, Емельяновский р-н, д. Минино, дом 42',
      tel: '+79836137003',
      whatsApp: '+79836137003',
      whatsAppLink: 'https://wa.me/79836137003',
      telegram: 'busyfly_sibir',
      telegramLink: 'https://t.me/busyfly_sibir',
      email: 'demetra_5@mail.ru',
    },
    {
      name: 'ИП Иляскин Иван Иванович',
      inn: '240403068845',
      city: 'г. Красноярск',
      legalAddress: 'Россия, Красноярский край, п. Березовка, ул. Заречная, 46-2',
      tel: '+79836137003',
      whatsApp: '+79836137003',
      whatsAppLink: 'https://wa.me/79836137003',
      telegram: 'busyfly_sibir',
      telegramLink: 'https://t.me/busyfly_sibir',
      email: 'artemast@mail.ru',
    },
    {
      name: 'ИП Энютин Максим Александрович',
      inn: '641797769614',
      city: 'г. Красный Кут',
      legalAddress: 'Россия, Саратовская область, г.Красный Кут, ул.Космольская 103/107 кв 28',
      tel: '+79603564978',
      whatsApp: '+79603564978',
      whatsAppLink: 'https://wa.me/79603564978',
      email: 'en.maxim@mail.ru',
    },
    {
      name: 'ИП Остапчук Василий Анатольевич',
      inn: '911019734079',
      city: 'Поселок городского типа Черноморское (Крым)',
      legalAddress: 'Россия, 296400 Республика Крым, п. Черноморское, ул. Агафонова 45А',
      tel: '+79780373330',
    },
    {
      name: 'ИП Борисов Владимир Иванович',
      inn: '525101793680',
      city: 'г. Кулебаки',
      legalAddress: 'Россия, Нижегородская обл., г. Кулебаки, ул. Бутова, д. 85, кв.20',
      tel: '89101204545',
      email: 'V.borisov@mostproject.ru',
    },
    {
      name: 'ИП Якимова Надежда Юрьевна',
      inn: '246302675322',
      city: 'г. Кызыл',
      legalAddress: 'Россия, 660016 Красноярский край, г.Красноярск, ул. А.Гладкова д.16 кв.76',
      tel: '+79937838790',
      email: 'yakimova.product@yandex.ru',
    },
    {
      name: 'ИП Хизриев Мухтар Багандович',
      inn: '056205093584',
      city: 'г. Махачкала',
      legalAddress: '367026, Россия, Дагестан, Махачкала, Имама Шамиля, 20 кв 17',
      tel: '+79884231656',
      whatsApp: '+79884231656',
      whatsAppLink: 'https://wa.me/79884231656',
      viber: '+79884231656',
      email: 'muk37105@mail.ru',
    },
    {
      name: 'ИП Иляскин Иван Иванович',
      inn: '240403068845',
      city: 'г. Междуреченск',
      legalAddress: 'Россия, Красноярский край, п. Березовка, ул. Заречная, 46-2',
      tel: '+79836137003',
      whatsApp: '+79836137003',
      whatsAppLink: 'https://wa.me/79836137003',
      telegram: 'busyfly_sibir',
      telegramLink: 'https://t.me/busyfly_sibir',
      email: 'artemast@mail.ru',
    },
    {
      name: 'ИП Морозова Елена Сергеевна',
      inn: '773272780973',
      city: 'г. Можайск',
      legalAddress: '119620, Россия, г. Москва, Солнцевский пр-кт д.15, кв.21',
      tel: '89035630806',
      email: 'Alexandr19862017@mail.ru'
    },
    {
      name: 'ООО «ГелиосСофт»',
      inn: '5406785743',
      city: 'г. Москва',
      legalAddress: '115487, Россия, г. Москва, пр-кт Андропова, д. 28, кв. 167',
      tel: '+79645007129',
      email: 'sales@geliossoft.ru',
    },
    {
      name: 'ИП Свистунов Роман Александрович',
      inn: '234200322110',
      city: 'г. Мостовской',
      legalAddress: 'Россия, п.Мостовской ул.Чапаева 21',
      tel: '+79184402363',
      email: 'romalsv@gmail.com',
    },
    {
      name: 'ИП Буданов Владимир Леонидович',
      inn: '510900853139',
      city: 'г. Мурманск',
      legalAddress: '183031, Россия, г. Мурманск, ул. Свердлова, д.8, к.3, оф.15',
      tel: '+79211532349',
      email: 'vladimir_budanov@mail.ru',
    },
    {
      name: 'ИП Янковская Лиза Юрьевна',
      inn: '760604919901',
      city: 'г. Мышкин',
      legalAddress: 'Россия, г. Ярославль, пр-т Ленина, д. 31, кв. 10',
      telegram: 'BusyFly_Support',
      telegramLink: 'https://t.me/BusyFly_Support',
      email: 'casablanca 05@mail.ru',
    },
    {
      name: 'ИП Рахимов Имамали Аграхим Оглы',
      inn: '070709686708',
      city: 'г. Нальчик',
      legalAddress: 'Россия, с. Виноградное, ул. Молодежная , дом 3, кв.13',
      tel: '+78002013028',
      whatsApp: '+79286933798',
      whatsAppLink: 'https://wa.me/79286933798',
      email: 'busyflynalchik@gmail.com',
    },
    {
      name: 'ИП Джулдузбаева Аделина Аскаровна',
      inn: '300803252589',
      city: 'г. Нариманов',
      legalAddress: 'Россия, Астраханская область, м.р-н Наримановский с.п. Солянский сельсовет, с. Солянка',
      tel: '+79627517518',
      email: 'adelinamotorina2022@gmail.com',
    },
    {
      name: 'ИП Хохлов Илья Адреевич',
      inn: '246315623547',
      city: 'г. Нижнекамск',
      legalAddress: 'г. Красноярск, ул. Лесопарковая, д. 9, кв. 223',
      tel: '+79193195511',
      whatsApp: '+79193195511',
      whatsAppLink: 'https://wa.me/79193195511',
      email: 'ipkhohohlov@yandex.ru',
    },
    {
      name: 'ООО АХАХА',
      inn: '6678113130',
      city: 'г. Нижний Тагил',
      legalAddress: 'Свердловская обл., г. Березовский, ул. Энергостроителей, д. 6, кв. 46',
      tel: '+79827571522',
      whatsApp: '+79827571522',
      whatsAppLink: 'https://wa.me/79827571522',
      telegram: 'samokatekat',
      telegramLink: 'https://t.me/samokatekat',
      viber: '+79827571522',
      email: 'samokat.ekat@mail.ru',
    },
    {
      name: 'ИП Кузнецов Игорь Евгеньевич',
      inn: '631930113386',
      city: 'г. Новокуйбышевск',
      legalAddress: '443028, Россия, г. Самара, п. Мехзавод, ул. 1й квартал, дом 38, кв. 228',
      whatsApp: '+79270274232',
      whatsAppLink: 'https://wa.me/79270274232',
      telegram: 'BusyFly_Samara_Support',
      telegramLink: 'https://t.me/BusyFly_Samara_Support',
      email: 'busyflypartners@mail.ru',
    },
    {
      name: 'ИП Иляскин Иван Иванович',
      inn: '240403068845',
      city: 'г. Новокузнецк',
      legalAddress: 'Россия, Красноярский край, п. Березовка, ул. Заречная, 46-2',
      tel: '+79836137003',
      whatsApp: '+79836137003',
      whatsAppLink: 'https://wa.me/79836137003',
      telegram: 'busyfly_sibir',
      telegramLink: 'https://t.me/busyfly_sibir',
      email: 'artemast@mail.ru',
    },
    {
      name: 'ИП Зарембо Юрий Владимирович',
      inn: '760601169432',
      city: 'г. Орел',
      legalAddress: 'Россия, г. Ярославль проспект Ленина д. 11/74, кв. 124',
      whatsApp: '+79962407505',
      whatsAppLink: 'https://wa.me/79962407505',
      telegram: 'Busy_Fly',
      telegramLink: 'https://t.me/Busy_Fly',
      email: 'artem.melnikov21@bk.ru',
    },
    {
      name: 'ИП Мурышкин Александр Владимирович',
      inn: '503407988471',
      city: 'г. Орехово-Зуево',
      legalAddress: 'Россия, 142600, г. Орехово-Зуево ул. Иванова д. 7 к.31',
      tel: '+79165428823',
    },
    {
      name: 'ИП Мокриенко Максим Станиславович',
      inn: '410551730956',
      city: 'г. Петропавловск-Камчатский',
      legalAddress: '3684017, Россия, Камчатский край, Елизовский р-н, посёлок Светлый, ул. Кооперативная, д. 11',
      tel: '+79024620906',
      whatsApp: '+79024620906',
      whatsAppLink: 'https://wa.me/79024620906',
      telegram: 'elizovo_busyfly',
      telegramLink: 'https://t.me/elizovo_busyfly',
      email: 'mpowerless@gmail.com',
    },
    {
      name: 'ИП Янковская Лиза Юрьевна',
      inn: '760604919901',
      city: 'г. Переславль-Заллесский',
      legalAddress: 'Россия, г. Ярославль, пр-т Ленина, д. 31, кв. 10',
      telegram: 'BusyFly_Support',
      telegramLink: 'https://t.me/BusyFly_Support',
      email: 'casablanca 05@mail.ru',
    },
    {
      name: 'ИП Рамазанов Султанбек Амиргамзаевич',
      inn: '054805043408',
      city: 'г. Первомайск',
      legalAddress: 'Россия, г. Избербаш. ул. Ритм 445',
      tel: '+79038517294',
      telegram: 'ramazanovsss',
      telegramLink: 'https://t.me/ramazanovsss',
      email: 'ramazanovrrrsss@mail.ru',
    },
    {
      name: 'ИП Хохлов Илья Адреевич',
      inn: '246315623547',
      city: 'г. Первоуральск',
      legalAddress: 'г. Красноярск, ул. Лесопарковая, д. 9, кв. 223',
      tel: '+79193195511',
      whatsApp: '+79193195511',
      whatsAppLink: 'https://wa.me/79193195511',
      email: 'ipkhohohlov@yandex.ru',
    },
    {
      name: 'ИП Горбатов Михаил Семенович',
      inn: '772496403592',
      city: 'г. Подольск',
      legalAddress: 'Россия, г. Москва, Бартеневская 13, 160',
      tel: '+79057770553',
      email: 'misha.miller@yandex.ru',
    },
    {
      name: 'ИП Родионова Татьяна Олеговна',
      inn: '662601569150',
      city: 'г. Полевской',
      legalAddress: 'Свердловская область, г Полевской, мкр Ялунина, д 21, кв 27',
      tel: '+79086367172',
      whatsApp: '+79086367172',
      whatsAppLink: 'https://wa.me/79086367172',
      telegram: 'BusyFly_Polevskoy',
      telegramLink: 'https://t.me/BusyFly_Polevskoy',
      email: 'romanlove@yandex.ru',
    },
    {
      name: 'ИП Булыгин Антон Эдуардович',
      inn: '673203563679',
      city: 'г. Псков',
      legalAddress: '214036, Россия, Смоленская обл, г Смоленск, ул Петра Алексеева, д. 10, кв. 43',
      whatsApp: '+375292455545',
      whatsAppLink: 'https://wa.me/375292455545',
      telegram: 'busyfly2023',
      telegramLink: 'https://t.me/busyfly2023',
      viber: '+375292455545',
      email: 'Marthen@bk.ru',
    },
    {
      name: 'ИП Блохина Юлия Борисовна',
      inn: '761009102630',
      city: 'г. Рыбинск',
      legalAddress: '152903, Ярославская область, г. Рыбинск, пр-т Ленина, 159-2',
      whatsApp: '+79301234007',
      whatsAppLink: 'https://wa.me/79301234007',
      telegram: 'BusyFly_ryb',
      telegramLink: 'https://t.me/BusyFly_ryb',
      email: 'cherbusyfly@gmail.com',
    },
    {
      name: 'ИП Хохлов Илья Адреевич',
      inn: '246315623547',
      city: 'г. Ревда',
      legalAddress: 'г. Красноярск, ул. Лесопарковая, д. 9, кв. 223',
      tel: '+79193195511',
      whatsApp: '+79193195511',
      whatsAppLink: 'https://wa.me/79193195511',
      email: 'ipkhohohlov@yandex.ru',
    },
    {
      name: 'ИП Войнова Елена Николаевна',
      inn: '720207067701',
      city: 'г. Репино',
      legalAddress: 'Россия, Тюменская область, г. Тюмень, ул. Елизарова, д. 6, кв. 99',
      tel: '88005502187',
      email: 'toplivot@inbox.ru',
    },
    {
      name: 'ИП Лесников Андрей Викторович',
      inn: '616126982221',
      city: 'г. Ростов на Дону',
      legalAddress: '344002, Россия, Ростовская область г. Ростов-на-Дону ул. Левобережная д. 5',
      tel: '+79185755932',
      whatsApp: '+79185755932',
      whatsAppLink: 'https://wa.me/79185755932',
      telegram: 'Rostov_technik_1',
      telegramLink: 'https://t.me/Rostov_technik_1',
      email: 'busyfly_technik_rnd@mail.ru',
    },
    {
      name: 'ИП Янковская Лиза Юрьевна',
      inn: '760604919901',
      city: 'г. Ростов',
      legalAddress: 'Россия, г. Ярославль, пр-т Ленина, д. 31, кв. 10',
      telegram: 'BusyFly_Support',
      telegramLink: 'https://t.me/BusyFly_Support',
      email: 'casablanca 05@mail.ru',
    },
    {
      name: 'ИП Войнова Елена Николаевна',
      inn: '720207067701',
      city: 'г. Рощино',
      legalAddress: 'Россия, Тюменская область, г. Тюмень, ул. Елизарова, д. 6, кв. 99',
      tel: '88005502187',
      email: 'toplivot@inbox.ru',
    },
    {
      name: 'ИП Козлов Руслан Юрьевич',
      inn: '781698500956',
      city: 'г. Санкт-Петербург',
      legalAddress: '192283, Россия, г. Санкт-Петербург, б-р Загребский, д. 33, корп. 2, кв. 75',
      tel: '+79643300330',
      whatsApp: '+79643300330',
      whatsAppLink: 'https://wa.me/79643300330',
      telegram: 'busyflyspb',
      telegramLink: 'https://t.me/busyflyspb',
      email: 'admin@busy-fly.spb',
    },
    {
      name: 'ИП Чурсин Дмитрий Андреевич',
      inn: '673006856845',
      city: 'г. Сафоново',
      legalAddress: 'Россия, обл. Смоленская. г. Смоленск, ул. Николаева д.46, кв.42',
      tel: '+79203178925',
      email: 'd.chursin@list.ru',
    },
    {
      name: 'ИП Сердюков Егор Павлович',
      inn: '191006977404',
      city: 'г. Саяногорск',
      legalAddress: '655132, Россия, Респ Хакасия, Усть-Абаканский р-н, село Зеленое,ул Гагарина,дом 8,кв 14',
      tel: '89617431117',
      email: 'zhora_serdyukov@mail.ru',
    },
    {
      name: 'ИП Якимова Надежда Юрьевна',
      inn: '246302675322',
      city: 'г. Саянск',
      legalAddress: 'Россия, 660016 Красноярский край, г.Красноярск, ул. А.Гладкова д.16 кв.76',
      tel: '+79937838790',
      email: 'yakimova.product@yandex.ru',
    },
    {
      name: 'ИП Козлов Руслан Юрьевич',
      inn: '781698500956',
      city: 'г. Сертолово',
      legalAddress: '192283, Россия, г. Санкт-Петербург, б-р Загребский, д. 33, корп. 2, кв. 75',
      tel: '+79643300330',
      whatsApp: '+79643300330',
      whatsAppLink: 'https://wa.me/79643300330',
      telegram: 'busyflyspb',
      telegramLink: 'https://t.me/busyflyspb',
      email: 'admin@busy-fly.spb',
    },
    {
      name: 'ИП Афанасьева Вероника Олеговна',
      inn: '390508305174',
      city: 'г. Светлый',
      legalAddress: 'Россия, 236019, Калининградская область, город Калининград,  улица Беланова, дом 27, квартира 57',
      viber: '+79097894545 (Работает только в режиме чата)',
      telegram: 'BusyFly_Kgd39',
      telegramLink: 'https://t.me/BusyFly_Kgd39',
      email: 'busy.fly@mail.ru'
    },
    {
      name: 'ИП Поляков Владислав Алексеевич',
      inn: '470709128599',
      city: 'г. Сланцы',
      legalAddress: '188560, Россия, Ленинградская обл, Сланцевский р-н, г. Сланцы, ул. Боровая, д. 8',
      tel: '+79218887688',
      email: 'ipodenkov@yandex.ru',
    },
    {
      name: 'ИП Челознов Сергей Владимирович',
      inn: '670901032560',
      city: 'г. Смоленск',
      legalAddress: 'Смоленская обл., Краснинский район, п.г.т. Красный пер.Озерный д.32',
      whatsApp: '+79303047438',
      whatsAppLink: 'https://wa.me/79303047438',
      telegram: 'busyfly_67_support',
      telegramLink: 'https://t.me/busyfly_67_support',
      email: 'Cheloznov@rambler.ru',
    },
    {
      name: 'ИП Булыгин Антон Эдуардович',
      inn: '673203563679',
      city: 'г. Смоленск',
      legalAddress: '214036, Россия, Смоленская обл, г Смоленск, ул Петра Алексеева, д. 10, кв. 43',
      whatsApp: '+375292455545',
      whatsAppLink: 'https://wa.me/375292455545',
      telegram: 'busyfly2023',
      telegramLink: 'https://t.me/busyfly2023',
      viber: '+375292455545',
      email: 'Marthen@bk.ru',
    },
    {
      name: 'ИП Афанасьева Вероника Олеговна',
      inn: '390508305174',
      city: 'г. Советск',
      legalAddress: 'Россия, 236019, Калининградская область, город Калининград,  улица Беланова, дом 27, квартира 57',
      viber: '+79097894545 (Работает только в режиме чата)',
      telegram: 'BusyFly_Kgd39',
      telegramLink: 'https://t.me/BusyFly_Kgd39',
      email: 'busy.fly@mail.ru'
    },
    {
      name: 'ИП Якимова Надежда Юрьевна',
      inn: '246302675322',
      city: 'г. Сосновоборск',
      legalAddress: 'Россия, 660016 Красноярский край, г.Красноярск, ул. А.Гладкова д.16 кв.76',
      tel: '+79937838790',
      email: 'yakimova.product@yandex.ru',
    },
    {
      name: 'ИП Ворожейкин Дмитрий Олегович',
      inn: '245907519528',
      city: 'г. Сосновоборск',
      legalAddress: '662313, Россия г. Шарыпово, кв. Листвяг, ул. Западная, д. 18, кв.1',
      tel: '8 923 368 83 59',
      email: 'dima21066@mail.ru',
    },
    {
      name: 'ИП Балаескул Эдуард',
      inn: '644206282661',
      city: 'г. Сосновый Бор',
      legalAddress: 'Санкт-Петербург, ул. Чичеренская 2, лит А, кв 13',
      tel: '+79218878688',
      viber: '+79218878688',
      whatsApp: '+79218878688',
      whatsAppLink: 'https://wa.me/79218878688',
      email: 'eduard.balaescul@gmail.com',
    },
    {
      name: 'ИП Роенко Светлана Вадимовна',
      inn: '251003919916',
      city: 'г. Спасск-Дальний',
      legalAddress: 'Россия, 692953, Приморский край, г. Находка, мкр. пос. Ливадия, ул. Надибаидзе, д. 5',
      tel: '+7 (994) 022-31-31',
      email: 'zyubanova.svetlana98@mail.ru',
    },
    {
      name: 'ИП Рябушкин Владислав Витальевич',
      inn: '641300661358',
      city: 'г. Степное',
      legalAddress: 'Россия, Саратовская область, г. Ершов, ул. 50 лет Октября д. 1, кв. 2',
      tel: '+79873616406',
      whatsApp: '+79873616406',
      whatsAppLink: 'https://wa.me/79873616406',
      telegram: 'Saratov_region_BusyFly',
      telegramLink: 'https://t.me/Saratov_region_BusyFly',
      email: 'Vlad15792@yandex.ru',
    },
    {
      name: 'ИП Черников Александр Владимирович',
      inn: '773208667988',
      city: 'г. Суздаль',
      legalAddress: '119313, г. Москва, Ленинский проспект 88к3, кв 101',
      whatsApp: '+79042605656',
      whatsAppLink: 'https://wa.me/79042605656',
      telegram: 'BusyFly33',
      telegramLink: 'https://t.me/BusyFly33',
      email: 'pro1702@gmail.com',
    },
    {
      name: 'ИП Валиев Олег Ленарович',
      inn: '112105770578',
      city: 'г. Сыктывкар',
      legalAddress: 'Россия, г. Сыктывкар, Республика Коми, пр-кт Бумажников д. 41/12 кв. 136',
      tel: '+79893574301',
      whatsApp: '+79129690304',
      whatsAppLink: 'https://wa.me/79129690304',
      email: 'lexs444@yandex.ru',
    },
    {
      name: 'ИП Зарембо Юрий Владимирович',
      inn: '760601169432',
      city: 'г. Тамбов',
      legalAddress: 'Россия, г. Ярославль проспект Ленина д. 11/74, кв. 124',
      whatsApp: '+79962407505',
      whatsAppLink: 'https://wa.me/79962407505',
      telegram: 'Busy_Fly',
      telegramLink: 'https://t.me/Busy_Fly',
      email: 'artem.melnikov21@bk.ru',
    },
    {
      name: 'ИП Арефьева Ксения Вячеславовна',
      inn: '410550993705',
      city: 'г. Темрюк',
      legalAddress: '684020, Камчатский край, Елизовский район, п. Раздольный, ул. 60 лет Октября, д. 7а',
      tel: '+79181200038',
      whatsApp: '+79181200038',
      whatsAppLink: 'https://wa.me/79181200038',
      email: 'tvoipotok@mail.ru'
    },
    {
      name: 'ИП Зарембо Юрий Владимирович',
      inn: '760601169432',
      city: 'г. Тверь',
      legalAddress: 'Россия, г. Ярославль проспект Ленина д. 11/74, кв. 124',
      whatsApp: '+79962407505',
      whatsAppLink: 'https://wa.me/79962407505',
      telegram: 'Busy_Fly',
      telegramLink: 'https://t.me/Busy_Fly',
      email: 'artem.melnikov21@bk.ru',
    },
    {
      name: 'ИП Янковская Лиза Юрьевна',
      inn: '760604919901',
      city: 'г. Углич',
      legalAddress: 'Россия, г. Ярославль, пр-т Ленина, д. 31, кв. 10',
      telegram: 'BusyFly_Support',
      telegramLink: 'https://t.me/BusyFly_Support',
      email: 'casablanca 05@mail.ru',
    },
    {
      name: 'ИП Гайдаров Анатолий Евгеньевич',
      inn: '381713806130',
      city: 'г. Усть-Илимск',
      legalAddress: 'Россия, Иркутская область, г. Усть-Илимск, Проспект Мира, д.15, кв.54',
      tel: '+79027620551',
      email: 'gaidar_92@mail.ru',
    },
    {
      name: 'ИП Якимова Надежда Юрьевна',
      inn: '246302675322',
      city: 'г. Черемхово',
      legalAddress: 'Россия, 660016 Красноярский край, г.Красноярск, ул. А.Гладкова д.16 кв.76',
      tel: '+79937838790',
      email: 'yakimova.product@yandex.ru',
    },
    {
      name: 'ИП Алыпов Илья Владимирович',
      inn: '190113425773',
      city: 'г. Черногорск',
      legalAddress: '655003, Россия, Республика Хакасия, г. Абакан, ул. Полярная 34',
      tel: '+79991791131',
      whatsApp: '+79991791131',
      whatsAppLink: 'https://wa.me/79991791131',
      email: 'Alipov_ilya@mail.ru'
    },
    {
      name: 'ИП Ананьин Кирилл Алексеевич',
      inn: '190307131074',
      city: 'г. Черногорск',
      legalAddress: '655003, Россия, Республика Хакасия, г. Абакан, ул. Полярная, д. 34',
    },
    {
      name: 'ИП Афанасьева Вероника Олеговна',
      inn: '390508305174',
      city: 'г. Черняховск',
      legalAddress: 'Россия, 236019, Калининградская область, город Калининград,  улица Беланова, дом 27, квартира 57',
      viber: '+79097894545 (Работает только в режиме чата)',
      telegram: 'BusyFly_Kgd39',
      telegramLink: 'https://t.me/BusyFly_Kgd39',
      email: 'busy.fly@mail.ru'
    },
    {
      name: 'ИП Якимова Надежда Юрьевна',
      inn: '246302675322',
      city: 'г. Шарыпово',
      legalAddress: 'Россия, 660016 Красноярский край, г.Красноярск, ул. А.Гладкова д.16 кв.76',
      tel: '+79937838790',
      email: 'yakimova.product@yandex.ru',
    },
    {
      name: 'ИП Скойбедо Владимир Михайлович',
      inn: '507900219095',
      city: 'г. Шаховская',
      legalAddress: '143700, Россия, пгт. Шаховская, ул. Шамонина д 23 кв 9',
      tel: '89617431117',
      email: 'skoibedo@gmail.com',
    },
    {
      name: 'ИП Котенко Эдуард Юрьевич',
      inn: '651801407704',
      city: 'г. Южно-Курильск',
      legalAddress: '694500, Россия, Сахалинская область, пгт. Южно-Курильск, ул. 60 лет ВЛКСМ 18-1',
      tel: '+79875223076',
      email: 'ipkoteu@mail.ru',
    },
    {
      name: 'ИП Останин Владимир Игоревич',
      inn: '246113680133',
      city: 'г. Якутск',
      legalAddress: '660025, Россия, Красноярский край, г. Красноярск, пер. Якорный, д. 17А, кв. 124',
      tel: '+79836137003',
      whatsApp: '+79836137003',
      whatsAppLink: 'https://wa.me/79836137003',
      telegram: 'busyfly_sibir',
      telegramLink: 'https://t.me/busyfly_sibir',
      email: 'chucker@bk.ru',
    },
    {
      name: 'ИП Хало Константин Анатольевич',
      inn: '246518000788',
      city: 'г. Якутск',
      legalAddress: '660012, Красноярский край, г. Красноярск, ул. Судостроительная, д 24 А, кв. 33',
      tel: '+79836137003',
      whatsApp: '+79836137003',
      whatsAppLink: 'https://wa.me/79836137003',
      telegram: 'busyfly_sibir',
      telegramLink: 'https://t.me/busyfly_sibir',
      email: 'konstantin.rus@icloud.com',
    },
    {
      name: 'ИП Зарембо Юрий Владимирович',
      inn: '760601169432',
      city: 'г. Ярославль',
      legalAddress: 'Россия, г. Ярославль проспект Ленина д. 11/74, кв. 124',
      whatsApp: '+79962407505',
      whatsAppLink: 'https://wa.me/79962407505',
      telegram: 'Busy_Fly',
      telegramLink: 'https://t.me/Busy_Fly',
      email: 'artem.melnikov21@bk.ru',
    },
    {
      name: 'ИП Янковская Лиза Юрьевна',
      inn: '760604919901',
      city: 'г. Ярославль',
      legalAddress: 'Россия, г. Ярославль, пр-т Ленина, д. 31, кв. 10',
      telegram: 'BusyFly_Support',
      telegramLink: 'https://t.me/BusyFly_Support',
      email: 'casablanca 05@mail.ru',
    },
  ];
}
